/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown>, partners: NonNullable<unknown>, conditions: NonNullable<unknown> }} Partner_Billing_Board_Filtered_Empty_BodyInputs */



/**
* | output |
* | --- |
* | "{month} lists {partners} partners. None is {conditions}. Widening any one filter brings rows back." |
*
* @param {Partner_Billing_Board_Filtered_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_filtered_empty_body = /** @type {((inputs: Partner_Billing_Board_Filtered_Empty_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Filtered_Empty_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.month} listet ${i?.partners} Partner. Keiner davon ist ${i?.conditions}. Wenn Sie einen Filter weiter fassen, erscheinen wieder Zeilen.`)
	return /** @type {LocalizedString} */ (`${i?.month} lists ${i?.partners} partners. None is ${i?.conditions}. Widening any one filter brings rows back.`)
});